import {Column, DataTable, Skeleton} from 'primereact';
import React, {useEffect, useState} from 'react'
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {CheckboxField} from "../../../Commons/Scripts/Componentes/CheckboxField";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, MessageProvider, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {CxpReporteService} from "../Services/cxp-reporte-service";
import {FechaUtils} from "../../../Commons/Scripts/Utils/fechaUtils";

const origin = window.location.origin;

function OcultarCero({ children, valor }) {
  return <React.Fragment>{valor === 0 ? null : <span>{children}</span>}</React.Fragment>;
}

function BodySuplidor(data, field, setExpandedRows, esNumero = false) {
  return (
    <div
      style={{ width: "100%", cursor: "pointer" }}
      onClick={() => {
        const key = data.SuplidorID;

        setExpandedRows((prev) => {
          if (prev?.some((p) => p.SuplidorID === key)) {
            return prev?.filter((p) => p.SuplidorID !== key);
          } else {
            return [...(prev || []), data];
          }
        });
      }}
    >
      {esNumero && <span>{formatear2Decimales(data[field])}</span>}
      {!esNumero && data[field]}
    </div>
  );
}

function TablaEstadoCuenta({ reporte, loading, expandedRows, setExpandedRows, contador }) {
  const suplidores = reporte?.reduce((acc, item) => {
    const key = item.SuplidorID;
    if (!acc[key]) {
      acc[key] = {
        SuplidorID: item.SuplidorID,
        SuplidorNombre: item.SuplidorNombre,
        MonedaFactura: item.MonedaFactura,
        documentos: [],
      };
    }
    acc[key].documentos.push(item);
    return acc;
  }, {});

  const rowExpansionTemplate = (suplidor) => {
    const monedas = [...new Set(reporte?.map((item) => item.MonedaFactura))];

    const TipoDocumento = {
      FACTURA_SUPLIDOR: "Factura Suplidor",
      ANTICIPO_CXP: "Anticipo",
      RETENCION: "Retencion",
      TRANSFERENCIA_BANCARIA: "Transferencia Bancaria",
      NOTA_CREDITO_CXP: "Nota de Crédito (CxP)",
      NOTA_DEBITO_CXP: "Nota de Débito (CxP)",
      PAGO_CONTADO_CXP: "Pago contado (CxP)",
    };

    const crearLink = (tipo, id) => {
      switch (tipo) {
        case TipoDocumento.FACTURA_SUPLIDOR:
          return `${origin}/CxP/factura_suplidor_edit.aspx?IdSec=${id}`;
        case TipoDocumento.RETENCION:
          return `${origin}/CxP/factura_suplidor_edit.aspx?IdSec=${id}`;
        case TipoDocumento.ANTICIPO_CXP:
          return `${origin}/CxP/anticipo_cxp_edit.aspx?IdSec=${id}`;
        case TipoDocumento.TRANSFERENCIA_BANCARIA:
          return `${origin}/Activos/transferencia_bancaria_edit.aspx?IdSec=${id}`;
        case TipoDocumento.NOTA_CREDITO_CXP:
          return `${origin}/CxP/nota_credito_cxp_edit.aspx?IdSec=${id}`;
        case TipoDocumento.NOTA_DEBITO_CXP:
          return `${origin}/CxP/nota_debito_cxp_edit.aspx?IdSec=${id}`;
        case TipoDocumento.PAGO_CONTADO_CXP:
          return `${origin}/CxP/pago_contado_edit.aspx?IdSec=${id}`;
        default:
          break;
      }
    };

    const crearLinkDocumentoAplicado = (id) => {
      return `${origin}/CxP/factura_suplidor_edit.aspx?IdSec=${id}`;
    };

    return (
      <div>
        {monedas?.length > 0 &&
          monedas?.map((moneda, index) => {
            const filtroMoneda = reporte?.filter((d) => d.MonedaFactura === moneda);

            const filtroSuplidor = filtroMoneda?.filter((d) => d.SuplidorID === suplidor.SuplidorID);

            const balanceInicial = {
              Tipo: "Balance Inicial",
              MonedaSimbolo: filtroSuplidor?.[0]?.MonedaSimbolo,
              Balance: filtroSuplidor?.[0]?.BalanceInicial,
            };

            const datos = [balanceInicial, ...filtroSuplidor];

            const totalMonto = filtroSuplidor?.reduce((acc, item) => {
              acc += item.DocMonto;
              return acc;
            }, 0);

            return (
              <div key={`${index}-${moneda}`}>
                {filtroSuplidor?.length > 0 && (
                  <React.Fragment>
                    <p>
                      Documentos en Moneda: <b>{moneda}</b>
                    </p>
                    <DataTable value={datos}>
                      <Column
                        field="DocDesc"
                        header="Documento"
                        footer="Balance Final"
                        body={(item) => (
                          <a className="link" href={crearLink(item.DocDesc, item.DocID)} target="_blank">
                            {item.DocDesc}
                          </a>
                        )}
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        field="DocID"
                        header="Id"
                        body={(item) => (
                          <a className="link" href={crearLink(item.DocDesc, item.DocID)} target="_blank">
                            {item.DocID}
                          </a>
                        )}
                      />
                      <Column field="NumeroFactura" header="No. Factura" />
                      <Column
                        body={(item) => {
                          if (!item.DocAplicado) {
                            return null;
                          }
                          const ids = item.DocAplicado.split(",");
                          const links = ids.map((id) => {
                            const url = crearLinkDocumentoAplicado(id);
                            return `<a class="link" href=${url} target="_blank">${id}</a>`;
                          });
                          return <span dangerouslySetInnerHTML={{ __html: links.join(", ") }}></span>;
                        }}
                        field="DocAplicado"
                        header="Doc. Aplicados"
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        body={(item) => {
                          const match = item?.DocFecha?.match(/\d+/);
                          const fechaMilisegundos = match ? Number(match[0]) : null;

                          return <span>{item?.DocFecha && new Date(fechaMilisegundos).toLocaleDateString()}</span>;
                        }}
                        header="Fecha"
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        body={(item) => {
                          const monto = item.DocMonto;

                          const numeroFormateado = formatear2Decimales(Math.abs(item.DocMonto));
                          const montoMostrar = monto < 0 ? `(${numeroFormateado})` : numeroFormateado;
                          const clases = `${monto < 0 ? "text-red" : ""}`;

                          return <span className={clases}>{item.DocMonto && montoMostrar}</span>;
                        }}
                        header="Monto"
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        body={(item) => {
                          const balance = item.Balance;

                          const numeroFormateado = formatear2Decimales(Math.abs(item.Balance));
                          const balanceMostrar = balance < 0 ? `(${numeroFormateado})` : numeroFormateado;
                          const clases = `${balance < 0 ? "text-red" : ""}`;

                          return <span className={clases}>{balanceMostrar}</span>;
                        }}
                        header="Balance"
                        footer={() => {
                          console.log();
                          const total = balanceInicial?.Balance + totalMonto;

                          return (
                            <span>
                              {balanceInicial?.MonedaSimbolo} {formatear2Decimales(total)}
                            </span>
                          );
                        }}
                      />
                    </DataTable>
                  </React.Fragment>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <React.Fragment>
      {reporte?.length > 0 && (
        <DataTable
          id="grid"
          value={Object.values(suplidores)}
          emptyMessage="No se han encontrado resultados"
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={(item) => rowExpansionTemplate(item)}
        >
          <Column
            expander
            style={{ width: "45px" }}
            body={(rowData) => {
              const isExpanded = expandedRows?.some((p) => p.SuplidorID === rowData.SuplidorID);

              return (
                <div
                  onClick={() => {
                    const key = rowData.SuplidorID;

                    setExpandedRows((prev) => {
                      if (prev?.some((p) => p.SuplidorID === key)) {
                        return prev?.filter((p) => p.SuplidorID !== key);
                      } else {
                        return [...(prev || []), rowData];
                      }
                    });
                  }}
                  className={`p-row-toggler ${isExpanded ? "expanded" : ""}`}
                >
                  <i className="pi pi-chevron-right"></i>
                </div>
              );
            }}
          />
          <Column
            headerClassName="alinear-derecha"
            style={{ textAlign: "right" }}
            body={(item) => BodySuplidor(item, "SuplidorID", setExpandedRows)}
            field="SuplidorID"
            header="Id"
          />
          <Column
            body={(item) => BodySuplidor(item, "SuplidorNombre", setExpandedRows)}
            field="SuplidorNombre"
            header="Suplidor"
          />
          <Column
            headerClassName="alinear-derecha"
            style={{ textAlign: "right" }}
            body={(item) => {
              const ultimoDocumentoPorMoneda = item?.documentos?.reduce((acc, item) => {
                const key = `${item.MonedaFactura}`;
                acc.set(key, item);
                return acc;
              }, new Map());

              const balanceFinal = [...ultimoDocumentoPorMoneda.values()];

              return (
                <div
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={() => {
                    const key = item.SuplidorID;

                    setExpandedRows((prev) => {
                      if (prev?.some((p) => p.SuplidorID === key)) {
                        return prev?.filter((p) => p.SuplidorID !== key);
                      } else {
                        return [...(prev || []), item];
                      }
                    });
                  }}
                >
                  {balanceFinal.map((data, i) => (
                    <div key={`${data.MonedaFactura}-${i}`}>
                      {data?.MonedaSimbolo} {formatear2Decimales(data?.Balance)}
                    </div>
                  ))}
                </div>
              );
            }}
            header="Balance Final"
          />
        </DataTable>
      )}

      {loading && contador === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </React.Fragment>
  );
}

function Formulario({
  suplidores,
  tiposFacturacion,
  tiposSuplidor,
  periodos,
  loadingDatos,
  onSubmit,
  valorInicial = {},
  onChange,
  filtro,
  where,
}) {
  const form = useForm(valorInicial);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.ESTADO_CUENTA_CXP, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.ESTADO_CUENTA_CXP, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.ESTADO_CUENTA_CXP, "CSV");

  useEffect(() => {}, [filtro]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      <div className="row">
        <SelectField
          isMulti
          name="suplidor"
          opciones={suplidores || []}
          label="Suplidor"
          placeholder="Todos"
          isLoading={loadingDatos}
          width="400px"
        />
      </div>

      <div className="row">
        <SelectField
          name="tipoFacturacion"
          opciones={tiposFacturacion || []}
          placeholder="Todos"
          label="Tipo Facturación"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
        <SelectField
          name="tipoSuplidor"
          opciones={tiposSuplidor || []}
          label="Tipo Suplidor"
          placeholder="Todos"
          isRow
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <div className="label"></div>
        <CheckboxField name="noMostrar" label="No Mostrar Documentos Por Aplicar" />
      </div>

      <div className="row">
        <SelectField
          name="periodo"
          opciones={periodos || []}
          label="Periodo"
          placeholder="Seleccione un periodo"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
        <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 125px",
        }}
      >
        <Button2 texto="Buscar" onClick={handleSubmit} />
        <Button2 texto="PDF" loading={loadingPdf} onClick={() => handlePdf(where)} />
        <Button2 texto="Excel" loading={loadingExcel} onClick={() => handleExcel(where)} />
        <Button2 texto="CSV" loading={loadingCsv} onClick={() => handleCsv(where)} />
      </div>
    </SimpleForm>
  );
}

export function EstadoResultado() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();
  const [expandedRows, setExpandedRows] = useState(null);

  const [loading, setLoading] = useState(false);
  const [where, setWhere] = useState({
    FechaInicio: FechaUtils.getSeisMesesAntes(),
    FechaFin: FechaUtils.getHoyFin(),
    IndiceDePagina: 0,
    CantidadPorPagina: 50,
  });
  const [total, setTotal] = useState(0);

  const [reporte, setReporte] = useState([]);

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [suplidores, setSuplidores] = useState();
  const [tiposFacturacion, setTiposFacturacion] = useState();
  const [tiposSuplidor, setTiposSuplidor] = useState();
  const [periodos, setPeriodos] = useState();

  const totalPaginas = Math.ceil(total / where.CantidadPorPagina ?? 0);

  useEffect(() => {
    setLoading(true);
    clearMessages();

    CxpReporteService.consultarEstadoCuenta(where)
      .then((res) => {
        setReporte((prevReporte) => [...prevReporte, ...res?.Resultados]);
        setTotal(res?.Total ?? 0);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([
      CxpReporteService.consultarSuplidores(),
      CxpReporteService.consultarTiposFacturacion(),
      CxpReporteService.consultarTiposSuplidor(),
      CxpReporteService.consultarPeriodos(),
    ])
      .then((res) => {
        setSuplidores(res[0]?.map((suplidor) => ({ value: suplidor.IdSec, label: suplidor.Nombre })));
        setTiposFacturacion(
          res[1]?.map((tipoFacturacion) => ({ value: tipoFacturacion.Value, label: tipoFacturacion.Label }))
        );
        setTiposSuplidor(res[2]?.map((tipoSuplidor) => ({ value: tipoSuplidor.IdSec, label: tipoSuplidor.Nombre })));
        setPeriodos(res[3]?.map((periodo) => ({ value: periodo.Value, label: periodo.Label })));
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  const handleFiltrar = (filtros) => {
    setReporte([]);
    setTotal(0);
    setWhere({
      ...filtros,
      IndiceDePagina: 0,
      CantidadPorPagina: 50,
    });
  };

  const handleMostrarMas = () => {
    setWhere((prevWhere) => ({
      ...prevWhere,
      IndiceDePagina: prevWhere.IndiceDePagina + 1,
    }));
  };

  const indice = (where.IndiceDePagina ?? 0) + 1;

  return (
    <div>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        suplidores={suplidores}
        tiposFacturacion={tiposFacturacion}
        tiposSuplidor={tiposSuplidor}
        periodos={periodos}
        loadingDatos={loadingDatos}
        onSubmit={(formulario) => {
          let fechaFin = new Date(formulario.fechaFin);
          const ahora = new Date();
          fechaFin.setHours(ahora.getHours(), ahora.getMinutes(), ahora.getSeconds(), ahora.getMilliseconds());

          const filtros = {
            SuplidorIdSecList: formulario.suplidor?.map((s) => s.value),
            TipoSuplidor: formulario.tipoSuplidor?.value != "-1" ? formulario.tipoSuplidor?.value : null,
            NoMostrarDocumentosPorAplicar: formulario.noMostrar,
            FechaInicio: formulario.fechaInicio,
            FechaFin: fechaFin,
            Periodo: formulario.periodo?.value != "-1" ? formulario.periodo?.value : null,
          };

          handleFiltrar(filtros);
        }}
        valorInicial={{
          fechaInicio: FechaUtils.getSeisMesesAntes(),
          fechaFin: FechaUtils.getHoyFin(),
        }}
        onChange={(formulario) => {}}
        where={where}
      />
      <TablaEstadoCuenta
        reporte={reporte}
        loading={loading}
        expandedRows={expandedRows}
        setExpandedRows={setExpandedRows}
        contador={indice}
      />
      {indice < totalPaginas && (
        <Button2 loading={loading} onClick={handleMostrarMas} texto={loading ? "Cargando..." : "Mostrar más"} />
      )}
    </div>
  );
}